import { SERVICE_REQUEST_ACTIVITIES_DRAFT_PREFIX } from '../../../constants/email'
import { EmailDraftProvider } from '../../Email'
import { useRequestProfileContext } from '../RequestProfile.hooks'

import { RequestProfileTabActivitiesContent } from './RequestProfileTabActivitiesContent'
import { RequestProfileTabActivitiesContextProvider } from './RequestProfileTabActivitiesContextProvider'

function RequestProfileTabActivities() {
  const { handleReloadRequestPhases, outboundUuid, requestData } =
    useRequestProfileContext()

  return requestData?.id ? (
    <EmailDraftProvider
      prefix={`${SERVICE_REQUEST_ACTIVITIES_DRAFT_PREFIX}-${requestData.id}`}
    >
      <RequestProfileTabActivitiesContextProvider
        outboundUuid={outboundUuid}
        requestId={requestData.id}
        onPhasesMetadataChange={handleReloadRequestPhases}
      >
        <RequestProfileTabActivitiesContent />
      </RequestProfileTabActivitiesContextProvider>
    </EmailDraftProvider>
  ) : null
}

export default RequestProfileTabActivities
